import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { Card, Divider, Typography } from 'antd';
import DarkModeToggle from '../components/DarkModeToggle';
import { useTheme } from '../context/ThemeContext';
import getEnv from '../env';

const { Text } = Typography;

function Footer() {
  const { isDarkMode } = useTheme();
  const version = getEnv('REACT_APP_VERSION');

  return (
    // antd renders children inside .ant-card-body, so the flex row has to be
    // declared on the body (styles.body) — on the Card root it would only lay
    // out that one wrapper div and leave the items as inline flow.
    <Card
      className="footer"
      styles={{
        body: {
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          columnGap: '16px',
          rowGap: '8px',
        },
      }}
    >
      <DarkModeToggle />
      {version && (
        <>
          <Divider type="vertical" />
          <Text type="secondary" style={{ fontSize: '12px' }}>{version}</Text>
        </>
      )}
      <Divider type="vertical" />
      <span>All rights reserved. {new Date().getFullYear()}.</span>
      <Divider type="vertical" />
      <Link to="/privacy">Privacy</Link>
      <Divider type="vertical" />
      <Link to="/consents">Consents</Link>
      <Divider type="vertical" />
      <Link to="/terms">Terms</Link>
      <Divider type="vertical" />
      {/* Always the Vellby mark, never useNodeSettings' per-node logo — this line
          attributes the platform, not the node serving the page. */}
      <Text type="secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
        <img
          src={isDarkMode ? '/white_outline.svg' : '/black_outline.svg'}
          alt=""
          style={{ width: 14, height: 14, verticalAlign: 'middle' }}
        />
        Vellby
      </Text>
    </Card>
  );
}

export default Footer;